import { useDropEventCard } from 'root/src/client/web/list/listItemComponents/dropEvent/hooks/useDropEventCard'
import { useBlackCardContext } from 'root/src/client/web/base/Card/BlackCard/hooks/useBlackCardContext'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLockOpen } from '@fortawesome/pro-regular-svg-icons/faLockOpen'
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock'
import { colorsNew } from 'root/src/client/web/commonStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import classnames from 'classnames'
import EarnPointsIcon from 'root/src/client/public/icons/ic-earn-points.svg'

const PrivateDropBannerLayout = withProjectCardStyle(({ classes }) => (
	<div className={classnames(
		classes.fullSize,
		classes.privateDropBannerLayoutContainer,
	)}
	>
		<div className={classnames(
			classes.flex,
			classes.flexCol,
			classes.flexCenter,
			classes.privateDropBannerLayoutContent,
		)}
		>
			<Typography variant={typographyVariants.heading3}>Private Drop</Typography>
		</div>
	</div>
))

const DropCardRequirements = withProjectCardStyle(({
	classes, canUserParticipate, requirements,
}) => {
	const { onOpenFaqSection } = useDropEventCard()
	return (
		<div
			className={classes.dropLockContainer}
		>
			<FontAwesomeIcon
				icon={canUserParticipate ? faLockOpen : faLock}
				size="lg"
			/>
			<div className={classes.tooltip}>
				{requirements.map(description => (
					description && (
						<div key={description} className={classes.requirementDisplay}>
							<Typography
								variant={typographyVariants.miniBold}
								color={colorsNew.light2}
								onClick={onOpenFaqSection}
							>
								{description}
							</Typography>
						</div>
					)
				))}
			</div>
		</div>
	)
})

export const DropEventHeader = withProjectCardStyle(({ classes }) => {
	const {
		dropEvent: { campaignName, isPrivate, gameObj, campaignThumbnail, awardPoints },
		extraData: { dropEventAccessibility: { canUserParticipate, display, requirements } },
	} = useDropEventCard()

	const { isHovered } = useBlackCardContext()

	const imageMod = gameObj?.image || addHttpsProtocol(campaignThumbnail?.url)

	return (
		<div className={classnames(classes.projectCardHeader, classes.positionInitial)}>
			<img
				className={classnames(classes.fullSizeImage, classes.smOpacity)}
				src={imageMod}
				alt={campaignName}
			/>
			{isHovered && (
				<div className={classes.ctaButtonOverlay}>
					<ButtonNew type="secondary">
						Check Out Dares
					</ButtonNew>
				</div>
			)}
			<div className={classnames(classes.badgesWrapper, classes.dropEventBadgesWrapper)}>
				<div className={classnames(classes.dropEventBadges)}>
					{awardPoints && (
						<div className={classnames(classes.dropLockContainer, classes.earnRewardsIcon)}>
							<img src={EarnPointsIcon.src} alt="Earn points" />
						</div>
					)}
				</div>
				<div className={classnames(classes.dropEventBadges, classes.justifyEnd)}>
					{display && (
						<DropCardRequirements
							requirements={requirements}
							canUserParticipate={canUserParticipate}
						/>
					)}
				</div>
			</div>
			<div
				className={classnames(
					classes.absolute,
					classes.flex,
					classes.flexCenter,
				)}
			>
				{!isHovered && isPrivate && <PrivateDropBannerLayout />}
			</div>
		</div>
	)
})
